<template>
  <div>
    <div class="has-content-margin">
      <div class="release-info">
        <div class="release-title">
          招标信息
        </div>
        <div class="release-content">
          <div class="release-tip">
            该任务已招标，请到人力市场完成应标评审。
          </div>
          <div class="release-op">
            <f7-link :href="`/project/releaseInfo/${projectId}?projectType=${projectType}`">
              <div class="realse-detail">
                <f7-icon icon="cicon-fabuxiangqing" size="0.8rem" color="gray"></f7-icon>
                <div style="margin-left: 0.2rem;">发布详情</div>
              </div>
            </f7-link>
            <f7-link @click="undoBid">
              <div class="realse-undo">
                <f7-icon icon="cicon-chexiao" size="0.8rem" color="gray"></f7-icon>
                <div style="margin-left: 0.2rem;">撤消</div>
              </div>
            </f7-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { undoRelease } from '@/api/team/worker';
import bus from '@/util/bus';
import { createToast } from '@/util/compUtils';

export default {
  props: ['projectId', 'projectType', 'perms'],
  data() {
    return {
    };
  },
  methods: {
    undoBid() {
      this.$f7.dialog.confirm('确认撤消此招标信息吗？', '温馨提示', () => {
        undoRelease({ projectId: this.projectId }).then((result) => {
          if (result.code === 0) {
            bus.$emit('refreshAssign');
            createToast(this, '撤消成功');
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .release-info {
    padding: 0rem 0rem;
  }

  .release-title {
    padding: 0rem 0.5rem;
    line-height: 2rem;
    text-align: left;
    border-top-left-radius: 0.5rem 0.5rem;
    border-top-right-radius: 0.5rem 0.5rem;
    background-color: #CAE8EA;
  }

  .release-content {
    border-left: 0.05rem solid $border-color;
    border-right: 0.05rem solid $border-color;
    border-bottom: 0.05rem solid $border-color;
    font-size: 0.8rem;
  }

  .release-tip {
    padding: 3rem 0rem;
    text-align: center;
    color: $second-color;
    font-size: 0.85rem;
  }

  .release-op {
    color: $font-color;
    display: flex;
    justify-content: flex-end;
    padding: 0rem 0rem 0.5rem 0rem;
  }

  .realse-detail {
    padding: 0rem 0.5rem;
    display: flex;
    align-items: center;
  }

  .realse-undo {
    padding: 0rem 2rem;
    display: flex;
    align-items: center;
  }

</style>



// WEBPACK FOOTER //
// src/pages/team/assignRelease.vue